const CREDIT_LIMITS_FORM_FIELDS = {
  type: "type",
  downPayment: "downPayment",
  downPaymentAmount: "downPaymentAmount",
  residualPayment: "residualPayment",
  residualPaymentAmount: "residualPaymentAmount",
  numberOfPeriods: "numberOfPeriods"
};
const DEFAULT_CREDIT_LIMITS_VALUES = {
  downPayment: 50,
  residualPayment: 25,
  numberOfPeriods: 48
};
export {
  CREDIT_LIMITS_FORM_FIELDS,
  DEFAULT_CREDIT_LIMITS_VALUES
};
